import { createSlice } from "@reduxjs/toolkit";
import { TimestampDB } from "../../models/articleModel";
import { db } from "../db/db";

interface DBState {
    dbTimestamps: TimestampDB[];
    dbLoading: boolean;
    dbUpdating: boolean;
}

const initialState: DBState = {
    dbTimestamps: [],
    dbLoading: false,
    dbUpdating: false,
};

export const getInitialDBTimestamp = () => async (dispatch: (arg0: { payload: any; type: string; }) => void) => {
    let res = await db.timestamps.toArray();
    if (res) {
        dispatch(setDBTimestamp(res));
    }
};

export const setDBLoadingState = (loading: boolean) => (dispatch: (arg0: { payload: any; type: "db/setDBLoading"; }) => void) => {
    dispatch(setDBLoading(loading));
}

export const setDBUpdatingState = (updating: boolean) => (dispatch: (arg0: { payload: any; type: "db/setDBUpdating"; }) => void) => {
    dispatch(setDBUpdating(updating));
}

const dbSlice = createSlice({
    name: "db",
    initialState,
    // non-async reducers
    reducers: {
        setDBTimestamp: (state, action) => {
            state.dbTimestamps = action.payload;
        },
        setDBLoading: (state, action) => {
            state.dbLoading = action.payload
        },
        setDBUpdating: (state, action) => {
            state.dbUpdating = action.payload
        }
    },
});




export const { setDBTimestamp, setDBLoading, setDBUpdating } = dbSlice.actions;
export default dbSlice.reducer;
